var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-status-widget__footer"},[_c('div',{staticClass:"sc-status-widget__footer-block"},[_c('r-text',[_vm._v(" "+_vm._s(_vm.$t("sc-status-widget:total"))+" ")])],1),_c('div',{staticClass:"sc-status-widget__footer-block"},[_c('r-title',[_vm._v(_vm._s(_vm.widgetData.total))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }